import { isLang, lang } from "@umu/ukit-lang";
import { ICalendarInfo, IFooterButItemInfo } from "../interface";
import dayjs from "dayjs";
import { IDateInfo } from "../interface/datePicker";
const weekList = [lang('一'), lang('二'), lang('三'), lang('四'), lang('五'), lang('六'), lang('日')]
const defaultFooterList: IFooterButItemInfo[] = [/*{
    key: 'clear',
    label: lang('清空'),
    type: 'text',
}, {
    key: 'cancel',
    label: lang('取消'),
    type: 'ghost-grey',
},*/ {
        key: 'submit',
        label: lang('确认'),
        type: 'primary-blue',
    }]
const onTransformWeekList = (list: string[]): string[] => {
    if (isLang('CN') || isLang('TW') || isLang('JP')) {
        return list;
    }
    return ['M', 'T', 'W', 'Th', 'F', 'S', 'Su']
}
const onTransformYearMonth = (list: [number, number]): string => {
    const [year, month] = list;
    if (isLang('CN')) {
        return `${year} 年 ${month} 月`
    }
    return `${month} / ${year}`;
}
const getCalendarHeardLabel = (info: ICalendarInfo) => {
    const { mode, value } = info
    if (mode === 'date') {
        const date = dayjs(value)
        return onTransformYearMonth([date.year(), date.month() + 1])
    }
    return ''
}
const MONTH_DAYS_COUNT = 42;
const getStartDate = (date: string) => {
    const monthStart = dayjs(date).startOf("month");
    const startWeekDay = monthStart.startOf("week");
    const isEqualDays = startWeekDay.format('YYYY-MM-DD') === monthStart.format('YYYY-MM-DD');
    // 如果当前月第一天正好为周日，需要取上一周的时间作为起始时间
    const startWeek = isEqualDays ? startWeekDay.subtract(1, "week") : startWeekDay;
    const startDate = startWeek.add(1, "day");
    return [startDate, monthStart]
}
const getDaysListByMonth = (info: ICalendarInfo) => {
    const { mode, value } = info
    const daysList: IDateInfo[] = [];
    if (mode !== 'date') {
        return daysList
    }
    // 如果当前月第一天正好为周日，需要取上一周的时间作为起始时间
    const [startDate, monthStart] = getStartDate(value);
    let day = startDate;
    let formatDate = "";
    while (daysList.length < MONTH_DAYS_COUNT) {
        for (let i = 0; i < 7; i++) {
            formatDate = day.format("D");
            const isNonCurrentMonth = !day.isSame(monthStart, "month");
            daysList.push({
                key: day.toString(),
                value: day.format("YYYY-MM-DD"),
                isNonCurrentMonth,
                className: `${isNonCurrentMonth ? "non-current-month" : "current-month"}`,
                label: formatDate,

            });
            day = dayjs(day).add(1, "day");
        }
    }
    return daysList
}
export {
    weekList,
    onTransformWeekList,
    defaultFooterList,
    getDaysListByMonth,
    getCalendarHeardLabel
}